<div class="text-center">
  <div class="spinner-border mt-5" style="width: 5rem; height: 5rem;" role="status">
      <span class="sr-only">{{message}}</span>
  </div>
</div>
<div class="text-center mb-5">
  <span>{{message}}</span>
</div>